/**
 * @file Constants for Product Combo feature
 */

/**
 * Business group options for Snacks & Beverages selection
 * @type {Array<{id: string, displayText: string}>}
 */
export const BUSINESS_GROUP_OPTIONS = [
  {id: 'SNK', displayText: 'Snacks'},
  {id: 'BVG', displayText: 'Beverages'},
]

/**
 * Business group display names mapping
 * @type {Object<string, string>}
 */
export const BUSINESS_GROUP_LABELS = {
  SNK: 'Snacks',
  BVG: 'Beverages',
}
